module.exports = __webpack_public_path__ + "static/media/chat-01.54e20dc0.png";